<template>
    <div class="ui tiny modal akademija-popup" ref="modal">
        <div class="content">
            <div class="close-button" v-on:click.stop="showRemind(365)">x</div>
            <input class="hide" type="checkbox" name="akademija_popup_2" value="true" ref="cookie-check" id="akademija-popup">
            <a class="button-1" href="https://www.modra-akademija.si/izobrazevanje/ucitelj-v-svetu-sprememb/" target="_blank" v-on:click="showRemind(365)"></a>
        </div>
    </div>
</template>

<script>
    import popup from './Popup.vue'

    export default {
        mixins: [popup],
        props: ['data'],
        methods: {
            onCookiePresent() {
                this.$root.$emit('close-popup', this);
            },
            showRemind(days = 1) {
                let cookieName = this.$refs['cookie-check'].name;
                this.$cookies.set(cookieName, true, 60 * 60 * 24 * days);
                this.$root.$emit('close-popup', this);
                $(this.$refs['modal']).modal('hide');
            },
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/modals/PopupAkademija.vue